import { render, staticRenderFns } from "./LinkToP2O.vue?vue&type=template&id=f97f1338&scoped=true"
import script from "./LinkToP2O.vue?vue&type=script&lang=js"
export * from "./LinkToP2O.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f97f1338",
  null
  
)

export default component.exports